const INITIAL_STATE = {
    desconto: {
        valorDesconto: 0,
        descricaoDesconto: null,
        motivoDesconto: null,
        formaDesconto: { value: '', label: '' },
        fonteDesconto: { value: 0, label: '' }
    },
    fatura: {},
    totalFaturas: 0,
    totalFaturasModal: 0,
    totalComissao: 0,
    totalComissaoModal: 0,
    totalReceber: 0,
    totalReceberModal: 0,
    totalDebito: 0,
    totalDebitoModal: 0,
    indexAtual: null,
    aPagar: 0,
    faturas: [],
    faturasPagamento: [],
    totaisGerais: {
        totalComissao: 0,
        totalReceber: 0,
        totalDebito: 0
    },
    totaisFormatado: {
        totalComissao: 0,
        totalReceber: 0,
        totalDebito: 0
    },
    cadastro: {
        data_vencimento: ''
    },
    pagar: {
        data_pagamento: new Date(),
        meio_pagamento: 0,
        forma_pagamento: ''
    },
    faturasCheckAll: false,
    faturasIdsSelecionadas: [],
    faturasSelecionadas: [],
    faturasChecked: [],
    clientesFaturas: [],
    bairros: [],
    dadosFiltro: {
        id: '',
        dataDe: '',
        dataAte: '',
        cliente: { value: 0, label: '' },
        status: [],
        segmento: { value: '', label: '' },
        tiposFatura: 'cliente',
        clear: false
    },
    // paginação da listagem de faturas de cliente
    currentPage: 1,
    lastPage: 1,
    totalRegistros: 0,
    valorTotal: 0,
    proximaSegunda: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case 'FATURAS_BAIRROS':
            return { ...state, bairros: action.payload }

        case 'FATURA_A_PAGAR_SET':
            console.log('FATURA_A_PAGAR_SET')
            return { ...state, aPagar: action.payload }

        case 'FATURAS_FETCHED':
            // console.log('FATURAS_FETCHED')
            // console.log(action.payload, 'fetched')
            return {
                ...state,
                faturas: action.payload.fatura.data,
                currentPage: action.payload.fatura.current_page || 1,
                lastPage: action.payload.fatura.last_page || 1,
                totalRegistros: action.payload.fatura.total || 0,
                totalFaturas: action.payload.totalFaturas,
                totalComissao: action.payload.totalComissao,
                totalReceber: action.payload.totalReceber,
                totalDebito: action.payload.totalDebito,
                proximaSegunda: action.payload.proximaSegunda
            }
        case 'FATURAS_SET_FETCHED':
            return { ...state, faturas: action.payload }
        case 'FATURAS_GET_FATURA':
            console.log('FATURAS_GET_FATURA', action.payload)
            let copyFatura = { ...action.fatura }
            copyFatura = action.payload

            const aPagarValor = copyFatura.valor_comissao ?? copyFatura.valor_a_receber

            const valorParaBR = (v) => {
                if (v == null || v === '') return ''
                const num = typeof v === 'number' ? v : parseFloat(String(v).replace(',', '.')) || 0
                return Number.isFinite(num) ? num.toFixed(2).replace('.', ',') : ''
            }

            if (copyFatura.pagamentos && copyFatura.pagamentos.length > 0) {

                copyFatura.pagamentosAntecipado = []

                const baseStorageUrl = `${process.env.REACT_APP_BACKEND_WEB || ''}storage/`

                for (const item of copyFatura.pagamentos) {
                    const forma = item.forma || {}
                    const comprovantesArquivos = Array.isArray(item.comprovantes)
                        ? item.comprovantes.map((c) => ({
                            isExisting: true,
                            url: c.arquivo && !String(c.arquivo).startsWith('http') ? `${baseStorageUrl}${c.arquivo}` : c.arquivo,
                            name: String(c.arquivo || '').split('/').pop(),
                            // Trava o pagamento no modal quando já conferido pela tesouraria.
                            conferido: Boolean(c?.conferido),
                            dataConferencia: c?.data_conferencia ?? null,
                            // Devolvida ao salvar para o comprovante recriado manter a data de inserção original.
                            dataAdicionado: c?.data_adicionado ?? null
                        }))
                        : []
                    copyFatura.pagamentosAntecipado.push({
                        valor: valorParaBR(item.valor),
                        formaPagamento: {
                            value: forma.pag_id,
                            label: forma.pag_nome,
                            pag_idtipo: forma.pag_idtipo ?? forma?.tipo?.id ?? null,
                            pag_credito: forma.pag_credito ?? 'NAO',
                            pag_cash: forma.pag_cash ?? 'NAO',
                            pag_debito: forma.pag_debito ?? 'NAO'
                        },
                        fontePagamento: item.fonte ? { value: item.fonte.id, label: item.fonte.nome } : { value: '', label: 'Selecione a fonte de pagamento!' },
                        parcela: { label: item.parcela.par_nome, value: item.parcela.par_id },
                        local: item.local ? item.local : "",
                        id: item.id,
                        comprovantesArquivos
                    })
                }
            } else {
                copyFatura.pagamentosAntecipado = []

                const valorInicialPagamento = copyFatura.valor_comissao ?? copyFatura.valor_a_receber ?? 0
                copyFatura.pagamentosAntecipado.push({
                    valor: valorParaBR(valorInicialPagamento) || '0,00',
                    formaPagamento: { label: 'Selecione a forma de pagamento!', value: '' },
                    fontePagamento: { label: 'Selecione a fonte de pagamento!', value: '' },
                    parcela: { label: '1X', value: 1 },
                    local: "",
                    comprovantesArquivos: []
                })
            }

            return { ...state, fatura: copyFatura, aPagar: aPagarValor }

        case 'FATURAS_GET_FATURAS': {
            let copyFatura = { ...action.fatura }
            const ids = []
            copyFatura = action.payload

            for (const item of copyFatura) {

                ids.push(item.id)

            }

            copyFatura.pagamentoId = ids

            copyFatura.pagamentosAntecipado = []

            return { ...state, fatura: copyFatura }

            // for (let item of copyFatura.dadosFatura) {

            //     item.pagamentosAntecipado = []

            //     console.log(item, 'item',pagamentos )

            //     if (item.pagamentos.length > 0) {

            //         for (const pag of item.pagamentos) {

            //             item.pagamentosAntecipado.push({
            //                 valor: pag.valor,
            //                 formaPagamento: { value: pag.forma.pag_id, label: pag.forma.pag_nome },
            //                 fontePagamento: { value: pag.fonte.id, label: pag.fonte.nome },
            //                 parcela: { label: pag.parcela.par_nome, value: pag.parcela.par_id },
            //                 local: pag.local ? pag.local : "",
            //                 id: pag.id
            //             })
            //         }
            //     } else {

            //         item.pagamentos.push({
            //             valor: "",
            //             formaPagamento: { label: 'Selecione a forma de pagamento!', value: '' },
            //             fontePagamento: { label: 'Selecione a fonte de pagamento!', value: '' },
            //             parcela: { label: '1X', value: 1 },
            //             local: "",

            //         })
            //     }

            //     pagamentos.push({
            //         pagamentosAntecipado: item.pagamentos,
            //         id: item.id
            //     })
            // }

            // return { ...state, faturasPagamento: copyFatura }
        }

        case 'FATURAS_UNCHECK':
            console.log('FATURAS_UNCHECK')
            return { ...state, faturasIdsSelecionadas: action.payload }

        case 'FATURAS_FORMATAR_FETCHED':
            console.log('FATURAS_FORMATAR_FETCHED')
            const total = { ...action.payload }

            let parseReceber = ''
            let parseDebito = ''
            let parseComissao = ''

            parseReceber = total.totalReceber.toString()
            parseComissao = total.totalComissao.toString()
            parseDebito = total.totalDebito.toString()

            total.totalReceber = parseReceber.replace('.', ',')
            total.totalComissao = parseComissao.replace('.', ',')
            total.totalDebito = parseDebito.replace('.', ',')

            return { ...state, totaisFormatado: total }

        case 'FATURAS_TOTAIS_GERAIS':
            console.log('FATURAS_TOTAIS_GERAIS')
            const totaisGeral = action.payload

            const totaisGerais = {
                totalReceber: totaisGeral.totalReceber,
                totalComissao: totaisGeral.totalComissao,
                totalDebito: totaisGeral.totalDebito
            }
            return { ...state, totaisGerais }
        case 'FATURAS_CADASTRO': {
            console.log('FATURAS_CADASTRO')
            const cadastroCopy = { ...state.cadastro }
            cadastroCopy[action.campo] = action.payload
            console.log(cadastroCopy, 'cadastroCopy')
            return { ...state, cadastro: cadastroCopy }
        }
        case 'FATURAS_PAGAR': {
            console.log('FATURAS_PAGAR')
            const cadastroCopy = { ...state.pagar }
            cadastroCopy[action.campo] = action.payload
            return { ...state, pagar: cadastroCopy }
        }
        case 'FATURAS_DADOS_EM_MASSA': {
            console.log('FATURAS_DADOS_EM_MASSA')
            console.log(action.payload, 'action.payload')
            return { ...state, clientesFaturas: action.payload }
        }

        // case 'FATURAS_CHECK': {
        //     console.log('FATURAS_CHECK')
        //     const allCheck = state.faturasCheckAll
        //     const copyFaturas = [...state.faturas]
        //     const faturasCopy = { ...copyFaturas[action.index] }
        //     faturasCopy.selecionado = action.value

        //     copyFaturas[action.index] = faturasCopy

        //     return { ...state, faturas: copyFaturas }
        // }

        case 'FATURAS_CHECK': {
            // const copyFaturas = state.faturas.map((fatura, index) => (index === action.index
            //     ? { ...fatura, selecionado: action.value }
            //     : fatura)
            // )

            // const allCheck =
            //     copyFaturas.length === 1 && !copyFaturas[0].selecionado
            //         ? false
            //         : copyFaturas.every((fatura) => fatura.selecionado)

            // return { ...state, faturas: copyFaturas, faturasCheckAll: allCheck }

            const copyFaturas = [...state.faturas]
            const faturasCopy = { ...copyFaturas[action.index] }
            faturasCopy.selecionado = action.value

            copyFaturas[action.index] = faturasCopy

            return { ...state, faturas: copyFaturas }
        }
        case 'FATURAS_RESERVAS_CHECK': {

            const copyFaturas = [...state.faturas]
            const acertoCopy = { ...copyFaturas[action.index] }
            const reservaCopy = { ...acertoCopy.reservas[action.indexReserva] }
            reservaCopy.selecionado = action.value

            acertoCopy.reservas[action.index] = reservaCopy
            copyFaturas[action.index] = acertoCopy

            return { ...state, faturas: copyFaturas }
        }
        case 'FATURAS_CHECK_ALL':
            console.log('FATURAS_CHECK_ALL')
            return { ...state, faturasCheckAll: !state.faturasCheckAll }

        case 'FATURA_ATUALIZAR_STATUS': {
            const { faturaId, status } = action.payload
            const copyFaturas = [...state.faturas]
            const index = copyFaturas.findIndex((f) => Number(f.id) === Number(faturaId))
            if (index === -1) return state
            const faturaCopy = { ...copyFaturas[index], status }
            copyFaturas[index] = faturaCopy
            return { ...state, faturas: copyFaturas }
        }

        case 'FATURA_REMOVER_LINHA_PAGAMENTOS_ANTECIPADOS': {
            console.log('FATURA_REMOVER_LINHA_PAGAMENTOS_ANTECIPADOS')
            const novosPagamentos = (state.fatura.pagamentosAntecipado || []).filter((pagamento, index) => index !== action.index)
            return { ...state, fatura: { ...state.fatura, pagamentosAntecipado: novosPagamentos } }
        }

        case 'FATURA_PAGAMENTO_ANTECIPADO_CHANGE_VALOR': {

            const copyFatura = { ...state.fatura }
            const copyValor = [...(copyFatura.pagamentosAntecipado || [])]
            var rowCopy = { ...copyValor[action.index] }

            // if (isNaN(action.payload)) {
            //     rowCopy['valor'] = Number(action.payload.replace(',', '.'))
            // } else {
            rowCopy['valor'] = action.payload
            // }

            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor
            console.log(copyValor, 'handle part 2')
            return { ...state, fatura: copyFatura }
        }

        case 'FATURA_PAGAMENTO_CHANGE_PAGAMENTOS_ANTECIPADOS': {
            console.log('FATURA_PAGAMENTO_CHANGE_PAGAMENTOS_ANTECIPADOS')
            const copyFatura = { ...state.fatura }
            const copyValor = [...(copyFatura.pagamentosAntecipado || [])]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['formaPagamento'] = action.payload
            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, fatura: copyFatura }
        }

        case 'FATURA_PAGAMENTO_ANTECIPADO_CHANGE_PARCELA': {
            console.log('FATURA_PAGAMENTO_ANTECIPADO_CHANGE_PARCELA')
            const copyFatura = { ...state.fatura }
            const copyValor = [...(copyFatura.pagamentosAntecipado || [])]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['parcela'] = action.payload
            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, fatura: copyFatura }
        }

        case 'FATURA_PAGAMENTO_CHANGE_FONTE_PAGAMENTOS_ANTECIPADOS': {
            console.log('FATURA_PAGAMENTO_CHANGE_FONTE_PAGAMENTOS_ANTECIPADOS')
            const copyFatura = { ...state.fatura }
            const copyValor = [...(copyFatura.pagamentosAntecipado || [])]
            var rowCopy = { ...copyValor[action.index] }

            rowCopy['fontePagamento'] = action.payload
            copyValor[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyValor

            return { ...state, fatura: copyFatura }
        }

        case 'FATURA_PAGAMENTO_ANTECIPADO_CHANGE_CAMPO': {
            const copyFatura = { ...state.fatura }
            const copyPagamentos = [...(copyFatura.pagamentosAntecipado || [])]
            const rowCopy = { ...copyPagamentos[action.index] }

            rowCopy[action.campo] = action.payload
            copyPagamentos[action.index] = rowCopy
            copyFatura.pagamentosAntecipado = copyPagamentos

            return { ...state, fatura: copyFatura }
        }

        case 'FATURAS_ABRIR_GRUPO': {
            console.log('FATURAS_ABRIR_GRUPO')
            const faturas = [...state.faturas]
            const index = action.index
            const atualIndex = action.indexAtual
            const teste = { ...faturas[index] }

            if ((atualIndex) && (index != atualIndex)) {
                const faturaAtual = { ...faturas[atualIndex] }
                faturaAtual.grupoAberto = false
                faturas[atualIndex] = faturaAtual
            } else if ((atualIndex) || index >= 0) {
                const faturaAtual = { ...faturas[atualIndex] }
                faturaAtual.grupoAberto = false
                faturas[atualIndex] = faturaAtual

            }

            teste.grupoAberto = !teste.grupoAberto
            faturas[index] = teste
            return { ...state, faturas, indexAtual: index }
        }

        case 'SELECIONAR_FATURA': {
            console.log('SELECIONAR_FATURA')
            const novasFaturasIdsSelecionadas = [...state.faturasIdsSelecionadas]
            const novasFaturasSelecionadas = [...state.faturasSelecionadas]
            const indexSelect = novasFaturasIdsSelecionadas.indexOf(action.payload) // Verifica se o número já existe no array
            const indexFaturaSelect = novasFaturasIdsSelecionadas.indexOf(action.fatura) // Verifica se o número já existe no array

            if (indexSelect === -1) {
                // Se não existir, adiciona o número ao array
                novasFaturasIdsSelecionadas.push(action.payload)
                novasFaturasSelecionadas.push(action.fatura)
            } else {
                // Se existir, remove o número do array
                novasFaturasIdsSelecionadas.splice(indexSelect, 1)
                novasFaturasSelecionadas.splice(indexFaturaSelect, 1)
            }

            let totalreceber = 0
            let totalcomissao = 0
            let totaldebito = 0
            let totalfaturas = 0

            console.log(novasFaturasSelecionadas[0])

            for (const selecionados of novasFaturasSelecionadas) {
                console.log('Entrou aqui totalreceber')

                totalreceber += isNaN(selecionados.totalReceberReserva) ? Number(selecionados.totalReceberReserva.replace(',', '.')) : Number(selecionados.totalReceberReserva)
                totaldebito += isNaN(selecionados.totalDebitoReserva) ?
                Number(selecionados.totalDebitoReserva.replace(',', '.')) :
                Number(selecionados.totalDebitoReserva)
                totalcomissao += isNaN(selecionados.totalComissaoReserva) ?
                Number(selecionados.totalComissaoReserva.replace(',', '.')) :
                Number(selecionados.totalComissaoReserva)

              
                totalfaturas += 1
            }

            return {
                ...state,
                faturasSelecionadas: novasFaturasSelecionadas,
                faturasIdsSelecionadas: novasFaturasIdsSelecionadas,
                totalFaturasModal: totalfaturas,
                totalComissaoModal: totalcomissao,
                totalReceberModal: totalreceber,
                totalDebitoModal: totaldebito
            }

        }

        case 'FATURA_CHECK_FATURAS_CLEAR':
            console.log('FATURA_CHECK_FATURAS_CLEAR')
            return { ...state, faturasSelecionadas: [], faturasIdsSelecionadas: [] }
        case 'FATURA_PAGAMENTOS_ANTECIPADOS_SET':
            const cadastroCopy = { ...state.fatura }
            cadastroCopy['pagamentosAntecipado'] = action.payload
            return { ...state, fatura: cadastroCopy }
        case 'FATURA_SET_FILTRO': {
            const dadosFiltroCopy = { ...state.dadosFiltro }
            dadosFiltroCopy[action.campo] = action.valor
            return { ...state, dadosFiltro: dadosFiltroCopy }
        }
        case 'FATURA_SET_FILTRO_CLEAR': {
            const dadosFiltroCopy = {
                id: '',
                dataDe: '',
                dataAte: '',
                cliente: '',
                status: [],
                segmento: { value: '', label: '' },
                tiposFatura: action.tiposFatura ?? state.dadosFiltro?.tiposFatura ?? 'cliente',
                clear: false
            }
            return { ...state, dadosFiltro: dadosFiltroCopy }
        }

        case 'FATURA_CHANGE_DESCONTO': {
            let copyDesconto = { ...state.desconto }

            console.log(action.payload?.forma, 'FATURA_CHANGE_DESCONTO')

            if (action.payload) {
                copyDesconto = {
                    valorDesconto: action.payload.valor,
                    descricaoDesconto: action.payload?.motivo_descricao
                        ? { value: action.payload.motivo_descricao.id, label: action.payload.motivo_descricao.nome }
                        : (action.payload?.motivo_id
                            ? { value: action.payload.motivo_id, label: action.payload?.descricao || '' }
                            : null),
                    motivoDesconto: action.payload?.tipo
                        ? {
                            value: action.payload.tipo,
                            label: action.payload.tipo_label
                                || (action.payload.tipo === 'AJUSTE_DE_ERRO' ? 'Ajuste de Erro' : 'Ajuste de Valor')
                        }
                        : null,
                    formaDesconto: action.payload?.forma ?
                        { value: action.payload?.forma, label: action.payload?.forma == 'DEBITO' ? 'Débito' : 'Crédito' } :
                        { value: 0, label: '' },
                    fonteDesconto: action.payload?.fontes ?
                        { value: action.payload?.fontes.id, label: action.payload?.fontes.nome } :
                        { value: 0, label: '' }
                }
            } else {
                copyDesconto = {
                    valorDesconto: 0,
                    descricaoDesconto: null,
                    motivoDesconto: null,
                    formaDesconto: { value: '', label: 'Selecione a forma de pagamento' },
                    fonteDesconto: { value: 0, label: 'Selecione a instituição financeira' }
                }
            }

            return { ...state, desconto: copyDesconto }
        }

        case 'FATURA_CHANGE_DESCONTOS_INPUT': {
            const copyDesconto = { ...state.desconto }

            if (action.name == 'valorDesconto') {
                let value = 0
                const raw = action.payload
                if (raw !== undefined && raw !== null && raw !== '') {
                    if (typeof raw === 'string' && raw.includes(',')) {
                        value = Number(raw.replace(',', '.'))
                    } else {
                        value = Number(raw)
                    }
                }

                copyDesconto[action.name] = value

            } else {

                copyDesconto[action.name] = action.payload
            }

            return { ...state, desconto: copyDesconto }

        }

        case 'FATURA_CALCULAR_VALOR_TOTAL': {
            const copyFatura = { ...state.fatura }
            let totalValor = 0

            console.log(copyFatura, 'facture')

            for (const faturaItem of copyFatura.pagamentosAntecipado || []) {

                if (isNaN(faturaItem.valor)) {
                    totalValor += Number(faturaItem.valor.replace(',', '.'))
                } else {
                    totalValor += Number(faturaItem.valor)
                }

            }

            return { ...state, valorTotal: parseFloat(totalValor).toFixed(2) }

        }

        default:
            return state
    }
}